<template>
    <DCard
        :title="__('settings.orders.order_clients.PSA')"
        padding
    >
        <DFormRow
            :label="__('settings.order_client.form.order_client')"
            :hint="__('settings.order_client.form.order_client_hint_psa')"
        >
            <DSwitch
                v-model="form.enabled"
                color="success"
                variant="3d"
            />
        </DFormRow>
        <DRow v-if="form.enabled">
            <DFormRow
                :label="__('settings.order_client.form.api_url')"
                :is-required="true"
                :error="errorsData.api_url ?? errorsData['PSA.api_url']"
                :hint="__('settings.order_client.form.api_url_hint_psa')"
            >
                <DInput
                    id="api_url"
                    v-model="form.api_url"
                    :placeholder="__('settings.order_client.form.api_url')"
                    :is-valid="isFormFieldValid('api_url')"
                    type="text"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.order_client.form.api_key')"
                :is-required="true"
                :error="errorsData.api_key ?? errorsData['PSA.api_key']"
                :hint="__('settings.order_client.form.api_key_hint_psa')"
            >
                <DInput
                    id="api_key"
                    v-model="form.api_key"
                    :placeholder="__('settings.order_client.form.api_key')"
                    :is-valid="isFormFieldValid('api_key')"
                    type="text"
                />
            </DFormRow>
            <DFormRow
                :label="__('settings.order_client.form.client_id')"
                :is-required="true"
                :error="errorsData.client_id ?? errorsData['PSA.client_id']"
                :hint="__('settings.order_client.form.client_id_hint')"
            >
                <DInput
                    id="client_id"
                    v-model="form.client_id"
                    :placeholder="__('settings.order_client.form.client_id')"
                    :is-valid="isFormFieldValid('client_id')"
                    type="number"
                />
            </DFormRow>
            <DRow>
                <DCol sm="4" />
                <DCol sm="4">
                    <div
                        v-if="connectionStatus === 'successful'"
                        class="green-text"
                    >
                        {{ __('settings.connections.connection_successful') }}
                    </div>
                    <div
                        v-if="connectionStatus === 'unsuccessful'"
                        class="red-text"
                    >
                        {{ __('settings.connections.connection_unsuccessful') }}
                    </div>
                </DCol>
                <DCol
                    sm="4"
                    class="check-database-connection-btn"
                >
                    <br>
                    <DButton
                        icon="lan-connect"
                        :label="__('settings.connections.check_connection')"
                        @click="checkConnection"
                    />
                </DCol>
                <DConnectionErrorModal
                    :show-modal="connectionException !== null"
                    :exception="connectionException"
                    @close-modal="closeErrorCheckModal"
                />
            </DRow>
        </DRow>
    </DCard>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { onUpdated, ref } from 'vue'

import { route } from '~@/Composables/route'
import DConnectionErrorModal from '~@/Components/Common/DConnectionErrorModal'

const props = defineProps({
    psaSettings: {
        type: Object,
        default: () => { return {} }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const emit = defineEmits(['form-submitted', 'psa-data', 'psa-valid'])

const form = useForm({
    order_client: props.psaSettings.order_client ?? 'PSA',
    enabled: props.psaSettings.enabled ?? false,
    api_url: props.psaSettings?.api_url ?? null,
    api_key: props.psaSettings?.api_key,
    client_id: props.psaSettings?.client_id
})

const connectionStatus = ref('')
const apiError = ref(null)
const errorsData = ref(props.errors)
const credentialsAreValid = ref(false)
const connectionException = ref(null)

emit('psa-data', form)
emit('psa-valid', !form.enabled || credentialsAreValid.value)

const checkConnection = () => {
    errorsData.value = {}
    connectionException.value = null
    window.axios.post(route('settings.order-settings.check-psa', form))
        .then(function () {
            connectionStatus.value = 'successful'
            credentialsAreValid.value = true
            emit('psa-valid', !form.enabled || credentialsAreValid.value)
        })
        .catch(function (error) {
            connectionStatus.value = 'unsuccessful'
            credentialsAreValid.value = false
            if (error.response.data.api_error !== undefined) {
                apiError.value = error.response.data.api_error
            }

            if (error.response.data.errors !== undefined) {
                errorsData.value = error.response.data.errors
                for (const key in errorsData.value) {
                    if (typeof errorsData.value[key] === 'object') {
                        errorsData.value[key] = errorsData.value[key][0]
                    }
                }
            }
            if (error?.response.data.exception !== undefined) {
                connectionException.value = error.response.data.exception
            }
        })
}

const closeErrorCheckModal = () => {
    apiError.value = null
    connectionException.value = null
}

onUpdated(() => {
    errorsData.value = props.errors
})
</script>

<script>
export default {
    name: 'PsaCreate'
}
</script>

<style lang="scss" scoped>
.check-database-connection-btn {
    text-align: right;
    padding-bottom: 12px;
}
.green-text {
    color: green;
}
.red-text {
    color: red;
}
</style>
